import { Axios } from "../axios";

export const getDocumentList = async (purposeCode: string, currency: string, type: any,loanDisbursementLetter:any) => {
  const purposeCodeValue =
    purposeCode === "Overseas Education - Living Expenses"
      ? "Overseas-Education-Living-Expenses"
      : purposeCode === "Overseas Education - University Fees"
      ? "Overseas-Education-University-Fees"
      : purposeCode === "Family Maintenance"
      ? "Family-Maintenance"
      : "Personal-Gift-Donation";

  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const remitterId = localStorage.getItem("remitter_key")

  try {
    const response = await Axios.get(`remit/user/recipient/docs`, {
      params: {
        purposeCode: purposeCodeValue,
        currency: currency,
        recipientType: type === null ? "Others" : type.replace(/\s+/g, "_"),
        userId:remitterId,
        loanDisbursementLetter:loanDisbursementLetter
      },
      headers: {
        Authorization: `${currentUser?.idToken}`,
      },
    });

    return response.data;
  } catch (error) {
    return error;
  }
};

export const getAdditionalDocFile = async (docId: string) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(`remit/user/${currentUser.idToken}/recipient/docId/${docId}`, {
      responseType: "blob",
      headers: {
        Authorization: `${currentUser.idToken}`,
        "Content-Type": "application/json",
      },
    });
  }
};
